import { useCallback, useState } from 'react';

import environment from '../environment/environment';
import ResultObject from '../interfaces/result-object';

const useEndTest = () => {
  const [endTestResult, setTestResult] = useState<ResultObject>({
    loading: false,
    message: {
      title: '',
      body: '',
    },
    redirectTo: '',
    result: '',
    status: '',
    submitted: false,
    score: '',
  });
  const [endTestResultError, setEndTestResultError] = useState(false);
  const confirmTestFinalizationGetResults = useCallback(
    (initializationObjectOEJR: any, urlParameters: any) => {
      const contactId = urlParameters?.contactId;
      const levelId = urlParameters?.levelId;
      const sessionId = initializationObjectOEJR?.result?.sessionId;
      const timeStamp = Date.now();
      setTestResult((prevState) => ({ ...prevState, loading: true }));
      fetch(
        `${environment.REACT_APP_OE_END_ACTIVITIES_SERVICE_URL}&contactId=${contactId}&sessionId=${sessionId}&levelId=${levelId}&_=${timeStamp}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      )
        .then((res) => {
          if (res.status === 200 || res.status === 422) {
            return res.json();
          }
          return false;
        })
        .then((response) => {
          if (!response) {
            resend();
          } else {
            setTestResult({
              ...response,
              loading: false,
              submitted: true,
            });
          }
        })
        .catch((err) => {
          setEndTestResultError(true);
          throw err;
        });

      const resend = () => {
        setTimeout(() => {
          confirmTestFinalizationGetResults(initializationObjectOEJR, urlParameters);
        }, 5000);
      };
    },
    [],
  );

  return {
    loading: endTestResult.loading,
    confirmTestFinalizationGetResults,
    endTestResult,
    testSubmitted: endTestResult.submitted,
    endTestResultError,
  };
};

export default useEndTest;
